import __request__ from "routing/request";
export function getEventsForThreatChain(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/threat_campaigns/events_for_threat_campaign/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSummary(eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/threat_campaigns/summary_for_event/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
